import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { DatePipe } from '@angular/common';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-session-cutoff-model-pop',
  templateUrl: './session-cutoff-model-pop.component.html',
  styleUrls: ['./session-cutoff-model-pop.component.scss']
})
export class SessionCutoffModelPopComponent implements OnInit {
  SessionCutOff: FormGroup;
  submitButton = true;
  subButton = false
  editButton = false;
  SessionFilterList: any;
  isdisabled = false;
  sessionList: any;
  collegeList: [];
  Table = false;
  filteredCollegeList: any[]=[];
  CourseList: any;
  filteredCourseList: any;
  userPermission: any;
  utp: any;
  sessCreate = true;
  sessUpdate = true;
  disableDate = false;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<SessionCutoffModelPopComponent>;
  DateArray: FormArray;
  CoCode: any;
  CoName: any;
  SnNo: any;
  ShId: any;
  submitpayload: any;
  currentdate;
  selectedDate: Date;
  errMsg: any;
  datearr: any;
  date: string;
  APIService: string;
  ExamAList: any;
  filteredExamAList: any;
  ExamInputList: any;
  filteredExamInputList: any;
  examDropdownVisible: boolean;
  isExamFeeType: boolean;
  UserCollege
  SelectAllActive: boolean = false;
  isSelectAll: boolean = false;  // Flag to disable other options
  selectedColleges = [];  // Array to store selected college codes
  selectedCourses = [];   // Array to store selected course codes
  commaSeparatedColleges: string;
  commaSeparatedCourses: string;
  feeTemplateWarningShown = false;
  showFeeTemplateWarning = false;
  constructor(public umsService: UmsService, public datepipe: DatePipe,
    private modalPopupService: ModalpopService,
    public dialogRef2: MatDialogRef<SessionCutoffModelPopComponent>,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder, private httpClient: HttpClient, public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute,) { this.APIService = environment.serviceUrl }
  todayDate: Date = new Date();
  ngOnInit(): void {
    this.isExamFeeType = false;
    this.Table = false;
    this.isSelectAll = true
    this.currentdate = new Date().setHours(0, 0, 0, 0);
    this.date = this.datepipe.transform(this.currentdate, 'yyyy-MM-dd');
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Session-Cutoff' && element.PCreate == false) {
          this.sessCreate = false;
        }
        if (element.PageName == 'Session-Cutoff' && element.PUpdate == false) {
          this.sessUpdate = false;
        }
      });
    }
    this.subButton = false;
    this.disableDate = false;
    this.SessionCutOff = this.fb.group({
      DateArray: this.fb.array([]),
      SessionID: new FormControl('', [Validators.required]),
      CoCgCgCode: new FormControl('', [Validators.required]),
      CoCgCoCode: new FormControl('', [Validators.required]),
      EmId: new FormControl(''),
      InCode: new FormControl('', [Validators.required]),
      // CutOffDate: new FormControl ('',[Validators.required]),
      SearchString: new FormControl(''),
      AMD: new FormControl(''),
    });

    if (this.data.key == "Edit") {
      this.prepopulateRecord(this.data.selected);

    }
    else if (this.data.key == "New") {
      this.fetchSecretData();
      this.initLoad();
    }
    this.action('d');
    
    this.fetchSupExamInputs();
  }

  isDatePassed(cutOffDate: Date): boolean {
    const todayDate = new Date(); // Get today's date
    const cutOff = new Date(cutOffDate); // Parse the cutOffDate into a Date object

    // Set time component to 00:00:00 for both dates
    todayDate.setHours(0, 0, 0, 0);
    cutOff.setHours(0, 0, 0, 0);

    // Check if cutOffDate is greater than today's date or same as today's date
    return cutOff < todayDate;
  }

  dateFilter = (date: Date | null): boolean => {
    let datesArray = this.SessionCutOff.get('DateArray') as FormArray;
    let dateValue = datesArray.value;
    const lastItem = dateValue[dateValue.length - 1];
    const hasEmptyCutOffDateFrom = dateValue.some(item => item.CutOffDateFrom === '' || item.CutOffDate === '' || item.CutOffDateFrom === null || item.CutOffDate === null);
    if (datesArray.value[0]['CutOffDate'] == '' || hasEmptyCutOffDateFrom) {
      this.disableDate = false
      if (!date) {
        const today = new Date().setHours(0, 0, 0, 0);
        return true; // Allow current date or future dates
      }

      const selectedDate = new Date(date).setHours(0, 0, 0, 0);
      const today = new Date().setHours(0, 0, 0, 0);
      // Compare selected date with today's date
      return selectedDate >= today;

    }
    else if (lastItem) {
      const today = new Date().setHours(0, 0, 0, 0);
      const cutOffDateFrom = this.datepipe.transform(lastItem.CutOffDateFrom, 'yyyy-MM-dd');
      const cutOffDate = this.datepipe.transform(lastItem.CutOffDate, 'yyyy-MM-dd');
      const todayFormatted = this.datepipe.transform(today, 'yyyy-MM-dd');
      const hasDate = cutOffDateFrom >= todayFormatted && cutOffDate >= todayFormatted;
      const hasdates = cutOffDateFrom < todayFormatted && cutOffDate < todayFormatted;
      if (hasdates) {
        this.disableDate = true;
      }
      else if (hasEmptyCutOffDateFrom) {
        this.disableDate = false
      }
      else {
        this.disableDate = false
      }


      if (hasDate) {
        const selectedDate = new Date(date).setHours(0, 0, 0, 0);
        const today = new Date().setHours(0, 0, 0, 0);
        // Compare selected date with today's date
        return selectedDate >= today;
      }
      else {
        return true;
      }
    }

    else {
      return true;
    }


  };

  action(d) {
    let taskListArrays = this.SessionCutOff.get('DateArray') as FormArray;
    if (taskListArrays.length >= 2) {
      let ttsskk = taskListArrays.length - 1;
      for (let index = 0; index <= ttsskk; index++) {
        const element = taskListArrays.controls[index];
        if (element.status == 'INVALID') {
          taskListArrays.controls[index].get('CutOffDate').setErrors(null)
          taskListArrays.controls[index].get('CutOffDateFrom').setErrors(null)
        }
      }
    }
  }

  datechange(i) {
    this.showFeeTemplateWarningOnce();
    let taskListArrays = this.SessionCutOff.get('DateArray') as FormArray;
    if (taskListArrays.controls[i].value.AMD == 'A') {
    } else {
      taskListArrays.controls[i].patchValue({ "AMD": "M" });
    }
    let formattedDate = this.datepipe.transform(taskListArrays.controls[i].value['CutOffDateFrom'], 'yyyy-MM-dd');
    if (taskListArrays.controls[i].value['CutOffDateFrom'] < this.currentdate || formattedDate < this.currentdate) {
      let data = []
      data['message'] = "Date Cannot Be Less Than Today's Date";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      // taskListArrays.controls[i]['CutOffDateFrom'].setValue('')
      taskListArrays.controls[i].get('CutOffDateFrom').setValue('');
      taskListArrays.controls[i].get('CutOffDateFrom').setErrors({ TodaydateError: true });
    }

    else {
      taskListArrays.controls[i].get('CutOffDateFrom').setErrors(null);
    }
    const formattedDateAsString = this.datepipe.transform(taskListArrays.controls[i].value.CutOffDateFrom, 'yyyy-MM-dd');
    if((formattedDateAsString > taskListArrays.controls[i].value.CutOffDate) && taskListArrays.controls[i].value.CutOffDate != ''){
      let data = {};
      data['message'] = "From Date Cannot Be Greater Than ToDate";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      // taskListArrays.controls[i]['CutOffDateFrom'].setValue('')
      taskListArrays.controls[i].get('CutOffDateFrom').setValue('');
    }

    if (taskListArrays.controls[i].value.CutOffDate != '' || taskListArrays.controls[i].value.CutOffDate == null) {

      if (taskListArrays.controls[i].value.CutOffDateFrom > taskListArrays.controls[i].value.CutOffDate) {
        let data = {};
        data['message'] = "From Date Cannot Be Greater Than ToDate";
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        // taskListArrays.controls[i]['CutOffDateFrom'].setValue('')
        taskListArrays.controls[i].get('CutOffDateFrom').setValue('');
      }
    }
   
    if(i > 0){
      const previousToDate = new Date(taskListArrays.controls[i - 1].value['CutOffDate']);
    const formattedDateAsString = this.datepipe.transform(previousToDate, 'yyyy-MM-dd');
    
    if (formattedDate === formattedDateAsString) {
      // taskListArrays.controls[i].get('CutOffDateFrom').setErrors({ SameDateError: true });
      let data = []
      data['message'] = "From Date Cannot Be Same As Previous ToDate";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      taskListArrays.controls[i].get('CutOffDateFrom').setValue('');
    }
    else if(formattedDate < formattedDateAsString){
      let data = []
      data['message'] = "From Date Cannot Be Less Than Previous ToDate";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      taskListArrays.controls[i].get('CutOffDateFrom').setValue('');
    }
    else {
      taskListArrays.controls[i].get('CutOffDateFrom').setErrors(null);
    }
    }
  }

  datechange1(i) {
    this.showFeeTemplateWarningOnce();
    let taskListArrays = this.SessionCutOff.get('DateArray') as FormArray;
    this.isDatePassed(taskListArrays.controls[i].value['CutOffDate'])
    let formattedDated = this.datepipe.transform(taskListArrays.controls[i].value['CutOffDate'], 'yyyy-MM-dd');
    if (taskListArrays.controls[i].value['CutOffDate'] < this.currentdate || formattedDated < this.currentdate) {
      let data = []
      data['message'] = "Date Cannot Be Less Than Today's Date";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      // taskListArrays.controls[i]['CutOffDateFrom'].setValue('')
      taskListArrays.controls[i].get('CutOffDate').setValue('');
    }

    else {
      taskListArrays.controls[i].get('CutOffDate').setErrors(null);
    }
    if (taskListArrays.controls[i].value.AMD == 'A') {
    } else {
      taskListArrays.controls[i].patchValue({ "AMD": "M" });
    }
    let Fromdate = taskListArrays.controls[i].value['CutOffDateFrom']
    let date = taskListArrays.controls[i].value['CutOffDate']
    if (date <= Fromdate) {
      taskListArrays.controls[i].get('CutOffDate').setErrors({ dateError: true });
      // this.errorcheckValidator(i)
    }
    else {
      taskListArrays.controls[i].get('CutOffDate').setErrors(null);
    }
  }

  selectSessionID(id) {
    this.Table = false;
    sessionStorage.setItem('SessionID', id);
  }

  fetchCourse(id) {
    this.Table = false;
    const payload = {};
    payload['CoCgCgCode'] = id;
    payload['SessionID'] = sessionStorage.getItem('SessId');
    this.umsService.getSessionColgCo(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredCourseList = this.CourseList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
      this.filteredCourseList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  getNextDay(selectedDate: Date): Date {
    if (selectedDate) {
      const nextDay = new Date(selectedDate);
      nextDay.setDate(selectedDate.getDate() + 1);
      return nextDay;
    }
    // If no date is selected, allow any date.
    return null;
  }

  getFormControls() {
    return (this.SessionCutOff.get('DateArray') as FormArray).controls;
  }


  addBtn() {
    this.disableDate = false
    const creds = this.SessionCutOff.controls.DateArray as FormArray;
    // this.action('d'); 
    // this.addNew()
    if (creds.invalid) {
      creds.controls.forEach(element => {
        element.get('CutOffDate').markAsTouched();
        element.get('CutOffDateFrom').markAsTouched();
        // element.get('OpMin').markAsTouched();
        // element.get('OpMax').markAsTouched();
      })
    } else {
      this.subButton = false;
      this.addNew()
    }
  }

  addNew() {
    const creds = this.SessionCutOff.controls.DateArray as FormArray;
    creds.push(
      this.fb.group({
        CutOffDate: new FormControl('', [Validators.required]),
        CutOffDateFrom: new FormControl('', [Validators.required]),
        AMD: new FormControl("A"),
      })
    );
  }

  initLoad() {
    let idd = '';
    this.editButton = false;
    this.submitButton = true;
    //  this.SessionCutOff.reset();
    this.isdisabled = false
    this.fetchSession(idd);
    //this.fetchCollege();
    // this.fetchSecretData();
    
    this.SessionCutOff = this.fb.group({
      DateArray: this.fb.array([]),
      SessionID: new FormControl('', [Validators.required]),
      CoCgCgCode: new FormControl('', [Validators.required]),
      CoCgCoCode: new FormControl('', [Validators.required]),
      EmId: new FormControl(''),
      InCode: new FormControl('', [Validators.required]),
      SearchString: new FormControl(''),
      AMD: new FormControl('A'),
    });
    // this.addNew();
  }

  fetchSession(id) {
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      this.sessionList = [];
      this.SessionFilterList = [];
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  fetchCollege() {
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    const payload = {};
    payload['CgCode'] = this.UserCollege;
    this.umsService.getCollege(payload).subscribe(res => {
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = []
      this.filteredCollegeList = []
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });

  }

  NewSearchCoSch(ShId) {
    const payload = {};
    payload['CEcShId'] = ShId;
    this.umsService.NewSearchCoSch(payload).subscribe(res => {
      if (res.status) {

        // this.RegnForm(res.data[0]['CEcId'])
      }
      else {
        this.CoEdit(ShId)
      }
    });
  }

  // NewCoSch2() {
  //   let payload2 = {}
  //   payload2 = this.SessionCutOff.value;
  //   const payload = {};
  //   payload['CoCode'] = payload2['CoCgCoCode'];;
  //   payload['CShStatus'] = '';
  //   payload['LoginId'] = sessionStorage.getItem('userId');
  //   payload['CShSnNo'] = parseInt(payload2['SessionID']);
  //   this.umsService.NewCoSch(payload).subscribe(res => {
  //     if (res.status) {
  //       this.NewSearchCoSch(res.data[0]['CShId'])
  //     }
  //   });
  // }

  submitFun1() {
      this.DateArray = this.SessionCutOff.get('DateArray') as FormArray;
    // this.action('d'); 
    // if (this.DateArray.invalid) {
    //   this.DateArray.controls.forEach(element => {
    //     element.get('CutOffDate').markAsTouched();
    //     element.get('CutOffDateFrom').markAsTouched();
    //   })
    // }
    // if (this.SessionCutOff.invalid) {
    //   this.SessionCutOff.get('SessionID').markAsTouched();
    //   this.SessionCutOff.get('CoCgCgCode').markAsTouched();
    //   this.SessionCutOff.get('CoCgCoCode').markAsTouched();
    //   // let x = (this.SessionCutOff.get('DateArray') as FormArray).controls;
    //   // x.forEach(element => {
    //   //   // element['controls']['CutOffDate'].markAsTouched();
    //   // });

    // }
    if (this.SessionCutOff.invalid) {
      this.subButton = false;
      if (this.SessionCutOff.value.InCode == 'EMFRM') {
        this.SessionCutOff.get('EmId').setValidators([Validators.required]);
        this.SessionCutOff.get('EmId').updateValueAndValidity();
        this.SessionCutOff.get('EmId').markAsTouched();
      }
      else if(this.SessionCutOff.value['Incode'] == 'EMFEE' || this.SessionCutOff.value['Incode'] == 'REMFE' || this.SessionCutOff.value['Incode'] == 'ADFEE'){
        this.SessionCutOff.get('EmId').setValidators([Validators.required]);
        this.SessionCutOff.get('EmId').updateValueAndValidity();
        this.SessionCutOff.get('EmId').markAsTouched();
      }
      else {
        this.SessionCutOff.get('EmId').clearValidators()
        this.SessionCutOff.get('EmId').updateValueAndValidity();
        this.SessionCutOff.get('EmId').markAsUntouched();
      }
      this.SessionCutOff.get('SessionID').markAsTouched();
      this.SessionCutOff.get('CoCgCgCode').markAsTouched();
      this.SessionCutOff.get('CoCgCoCode').markAsTouched();
      this.SessionCutOff.get('InCode').markAsTouched();
      let x = (this.SessionCutOff.get('DateArray') as FormArray).controls;
      x.forEach(element => {
        element['controls']['CutOffDate'].markAsTouched();
        element['controls']['CutOffDateFrom'].markAsTouched();
      });
      
    }
    else {
      this.subButton = true;
      if(this.SelectAllActive == true){
        this.submitAll();
      }
      else if(this.SelectAllActive == false){ 
        this.submit();
      }
      
      // this.courseShId()
    }
  }

  // courseShId() {
  //   const payload = {};
  //   payload['CoCode'] = this.SessionCutOff.value['CoCgCoCode']
  //   payload['CShStatus'] = '';
  //   payload['LoginId'] = sessionStorage.getItem('userId');
  //   payload['CShSnNo'] = this.SessionCutOff.value['SessionID']
  //   this.umsService.NewCoSch(payload).subscribe(res => {
  //     if (res.status) {
  //       this.checkRegister(res.data[0]['CShId'])
  //     }
  //     else{
  //       let data = {}
  //         data['message'] = "Course Is Not Scheduled. First Open Schedule For This Course and Open Its Registration List"
  //         data['title'] = 'Information'
  //         data['icon'] = 'fas fa-box'
  //         this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //     }
  //   });
  // }
  // checkRegister(ShId) {
  //   const payload = {};
  //   payload['CEcInCode'] = 51;
  //   payload['CEcShId'] = ShId;
  //   payload['CEcOpId'] = sessionStorage.getItem('userId');
  //   this.umsService.getSupCourseEditRecord(payload).subscribe(res => {
  //     if (res.status) {
  //       this.submit();
  //     }
  //     else{
  //       let data = {}
  //       data['message'] = "Course Registration List Not Open. First Open Registration List For This Course"
  //       data['title'] = 'Information'
  //       data['icon'] = 'fas fa-box'
  //       this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //     }
  //   });
  // }

  CourseData(data) {
    if (data && data.CoCode) {
    this.CoCode = data.CoCode;
    this.CoName = data.CoName;
    this.SnNo = data.SessionID;
    this.fetchCollegesForCourse(this.CoCode);
  } else {
    console.error('Invalid course data:', data);
  }

  }

  prepopulatedData(e) {
    console.log('this.commaSeparatedColleges',this.commaSeparatedColleges);
    
    this.DateArray = this.SessionCutOff.get('DateArray') as FormArray;
    this.DateArray.clear();
    let payload = {}
    payload['SessionID'] = e.SessionID;
    payload['CoCgCgCode'] = this.commaSeparatedColleges != undefined ? this.commaSeparatedColleges : e.CoCgCgCode;
    payload['CoCgCoCode'] = e.CoCgCoCode;
    payload['InCode'] = e.InCode;
    payload['EmId'] = e.EmId;
    this.umsService.findSessionCutOff(payload).subscribe(res => {
      if (res.status) {
        this.editButton = true;
        this.submitButton = false;
        this.DateArray = this.SessionCutOff.get('DateArray') as FormArray;
        this.DateArray.clear();
        this.Table = true;
        res.data.forEach(element => {
          // this.prepopulateNew(element);
          const creds = this.SessionCutOff.controls.DateArray as FormArray;
          creds.push(
            this.fb.group({
              CutOffDate: new FormControl(this.datepipe.transform(element.CutOffDate, 'yyyy-MM-dd'), [Validators.required]),
              CutOffDateFrom: new FormControl(this.datepipe.transform(element.CutOffDateFrom, 'yyyy-MM-dd'), [Validators.required]),
              AMD: new FormControl("M"),
              SessionCoColgCutOffDtId: new FormControl(element.SessionCoColgCutOffDtId),
            })
          );
        });
      }
      else {
        this.editButton = false;
        this.submitButton = true;
        this.DateArray = this.SessionCutOff.get('DateArray') as FormArray;
        this.DateArray.clear();
        this.Table = true;
        this.addNew();
      }

    })
  }

  prepopulateRecord(e) {
    this.spinner.show();
    this.editButton = true;
    this.feeTemplateWarningShown = false;
    this.showFeeTemplateWarning = false; 
    this.submitButton = false;
    this.isdisabled = true;
    this.SelectAllActive = false;
    const payload = {};
    
    payload['SessionID'] = e.SessionID;
    payload['CoCgCgCode'] = e.CoCgCgCode;
    payload['CoCgCoCode'] = e.CoCgCoCode;
    payload['InCode'] = e.InCode;
    payload['EmId'] = e.EmId;
    this.fetchSession('');
    this.fetchSecretData();
    this.fetchCollege();
    this.fetchCourse2()
    console.log('e',e);
    this.umsService.findSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.Table = true
        console.log('selected data',res.data);
        this.SelectAllActive = false;
        if (res.data[0]['InCode'] == 'EMFRM' || res.data[0]['InCode'] == 'MRKEN' || res.data[0]['InCode'] == "MRKL" || res.data[0]['InCode'] == "SubSe") {
          this.fetchSupExamRecord(res.data[0]['CoCgCoCode'])
          this.examDropdownVisible = true
        }
        if (res.data[0]['InCode'] == 'EMFEE' || res.data[0]['InCode'] == 'REMFE' || res.data[0]['InCode'] == 'ADFEE') {
          this.fetchSupExamRecord(res.data[0]['CoCgCoCode'])
          //this.isExamFeeType = true
          this.examDropdownVisible = false
        }
        this.fetchCollegesForCourse(res.data[0]['CoCgCoCode']);
        // this.fetchCourse1(res.data[0]['CoCgCgCode'], e.SessionID)
        // this.fetchCourse(res.data[0]['CoCgCgCode']);
        this.SessionCutOff.patchValue({
          SessionID: res.data[0]['SessionID'],
          CoCgCgCode: [res.data[0]['CoCgCgCode']],
          CoCgCoCode: res.data[0]['CoCgCoCode'],
          EmId: res.data[0]['EmId'],
          InCode: res.data[0]['InCode'],

        });

        this.DateArray = this.SessionCutOff.get('DateArray') as FormArray;
        this.DateArray.clear();

        res.data.forEach(element => {
          this.prepopulateNew(element);
        });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  showFeeTemplateWarningOnce() {
  if (this.editButton && !this.feeTemplateWarningShown) {
    this.showFeeTemplateWarning = true; 
    this.feeTemplateWarningShown = true;
  }
}

  fetchCourse1(id, session) {
    this.Table = false;
    const payload = {};
    payload['CoCgCgCode'] = id;
    payload['SessionID'] = session;
    this.umsService.getSessionColgCo(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredCourseList = this.CourseList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
      this.filteredCourseList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  prepopulateNew(e) {
    this.Table = true
    // this.action('d');
    const creds = this.SessionCutOff.controls.DateArray as FormArray;
    creds.push(
      this.fb.group({
        CutOffDate: new FormControl(this.datepipe.transform(e.CutOffDate, 'yyyy-MM-dd'), [Validators.required]),
        CutOffDateFrom: new FormControl(this.datepipe.transform(e.CutOffDateFrom, 'yyyy-MM-dd'), [Validators.required]),
        AMD: new FormControl(""),
        SessionCoColgCutOffDtId: new FormControl(e.SessionCoColgCutOffDtId),
      })
    );
  }


  CoEdit(Shid) {
    const payload = {};
    payload['CEcShId'] = Shid;
    payload['CEcDesc'] = 'New';
    payload['CEcInCode'] = 51;
    payload['CEcOpId'] = sessionStorage.getItem('userId');
    payload['CEcOpenOpId'] = sessionStorage.getItem('userId');
    payload['CEcStatus'] = 'O';
    payload['FrontCEcInCode'] = 51;
    payload['FrontList'] = '';
    payload['CEcListNo'] = '';
    payload['EcId'] = '';
    this.umsService.submitSupCourse(payload).subscribe(res => {
      if (res.status) {
        
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = []
      this.filteredCollegeList = []
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  NewCoSch() {
    this.submitpayload = this.SessionCutOff.value
    const payload = {};
    payload['CoCode'] = this.submitpayload['CoCgCoCode'];
    payload['CShStatus'] = '';
    payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
    payload['CShSnNo'] = this.submitpayload['SessionID'];
    this.umsService.NewCoSch(payload).subscribe(res => {
      if (res.status) {
        this.ShId = res.data['CShId']
        this.NewSearchCoSch(res.data[0]['CShId'])

      }
      else {
        this.CoSch();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = []
      this.filteredCollegeList = []
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  CoSch() {
    this.submitpayload = this.SessionCutOff.value
    const payload = {};
    payload['CShCoCode'] = this.CoCode;
    payload['CoName'] = this.CoName;
    payload['CShStatus'] = 'O';
    payload['CShPath'] = '';
    payload['CShId'] = '';
    payload['CShSnNo'] = this.submitpayload['SessionID'];
    this.umsService.addCoSch(payload).subscribe(res => {
      if (res.status) {
        this.NewCoSch()

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = []
      this.filteredCollegeList = []
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  submit1() {
    this.spinner.show();
    let payload = {}
    payload = this.SessionCutOff.value;
    
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload['DateArray'].forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            SessionID: new FormControl(payload['SessionID']),
            CoCgCgCode: new FormControl(payload['CoCgCgCode']),
            CoCgCoCode: new FormControl(payload['CoCgCoCode']),
            CutOffDate: new FormControl(this.datepipe.transform(element['CutOffDate'], 'yyyy-MM-dd')),
            CutOffDateFrom: new FormControl(this.datepipe.transform(element['CutOffDateFrom'], 'yyyy-MM-dd')),
            AMD: new FormControl(element['AMD']),
            SessionCoColgCutOffDtId: new FormControl(element['SessionCoColgCutOffDtId'] ? element['SessionCoColgCutOffDtId'] : 0),

          })
        )
        if (arr1[0].value["AMD"] == "M") {
          this.umsService.updateSessionCutOff(arr1[0].value).subscribe(res => {
            this.spinner.hide();
            if (res.status == false) {
              this.spinner.hide();
              iserror = true;
              this.errMsg = res.message
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false
              this.errMsg = res.message
            }
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          });
        } else if (arr1[0].value["AMD"] == "A") {
          this.umsService.addSessionCutOff(arr1[0].value).subscribe(res => {
            this.spinner.hide();
            if (res.status == false) {
              iserror = true;
              this.errMsg = res.message
            }
            if (index === array.length - 1) resolve();
            else {
              iserror = false
              this.errMsg = res.message
              // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
            }
            if (res.status == true) {
              iserror = false
              this.errMsg = res.message
              // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
            }
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            iserror = true;
            this.errMsg = ERROR.error.message
            if (index === array.length - 1) resolve();
          });
        }

      });
    })
    bar.then(() => {
      if (iserror == false) {
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close()
        });
      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      }
    });
  }


  submit() {
    let payload = {};
    payload = this.SessionCutOff.value;
    // const coCgCgCodes = (payload['CoCgCgCode'] || []).filter((code: string) => code !== 'selectAll');
    let coCgCgCodes: string[] = [];

if (this.editButton) {
  // Edit mode -> take all colleges under course
  // coCgCgCodes = this.filteredCollegeList.map(x => x.CoCgCgCode);
   coCgCgCodes = Array.isArray(payload['CoCgCgCode'])
    ? payload['CoCgCgCode'].filter((code: string) => code !== 'selectAll')
    : payload['CoCgCgCode']
    ? [payload['CoCgCgCode']]
    : [];
} else {
  // Existing flow
  coCgCgCodes = (payload['CoCgCgCode'] || [])
    .filter((code: string) => code !== 'selectAll');
}
    const baseBody = {
      SessionID: payload['SessionID'],
      CoCgCoCode: payload['CoCgCoCode'],
      EmId: payload['EmId'],
      InCode: payload['InCode'],
      CutOffDate: payload['DateArray'][0]['CutOffDate'],
      CutOffDateFrom: payload['DateArray'][0]['CutOffDateFrom'],
      SessionCoColgCutOffDtId: payload['DateArray'][0]['SessionCoColgCutOffDtId'],
    };
    if (coCgCgCodes.length === 0) {
      return;
    }
    const deleteCalls = coCgCgCodes.map((collegeCode: string) => {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: {
          ...baseBody,
          CoCgCgCode: collegeCode,
        },
      };
      return this.httpClient.delete(this.APIService + '/students/SessionCoColgCutOff', options);
    });
    forkJoin(deleteCalls).subscribe(
      () => {
        this.AddSessionCutOff();
      },
      (ERROR: HttpErrorResponse) => {
        this.subButton = false;
      }
    );
  }

  AddSessionCutOff() {
    this.spinner.show();
    let payload = {};
    payload = this.SessionCutOff.value;
    // const coCgCgCodes = (payload['CoCgCgCode'] || []).filter((code: string) => code !== 'selectAll');
    let coCgCgCodes: string[] = [];

if (this.editButton) {
  // Edit mode -> take all colleges under course
  // coCgCgCodes = this.filteredCollegeList.map(x => x.CoCgCgCode);
  coCgCgCodes = Array.isArray(payload['CoCgCgCode'])
    ? payload['CoCgCgCode'].filter((code: string) => code !== 'selectAll')
    : payload['CoCgCgCode']
    ? [payload['CoCgCgCode']]
    : [];
} else {
  // Existing flow
  coCgCgCodes = (payload['CoCgCgCode'] || [])
    .filter((code: string) => code !== 'selectAll');
}

    let iserror = false;
    const addCalls: any[] = [];
    (payload['DateArray'] || []).forEach((element: any) => {
      coCgCgCodes.forEach((collegeCode: string) => {
        const addPayload = {
          SessionID: payload['SessionID'],
          CoCgCgCode: collegeCode,
          CoCgCoCode: payload['CoCgCoCode'],
          EmId: payload['EmId'],
          InCode: payload['InCode'],
          CutOffDate: this.datepipe.transform(element['CutOffDate'], 'yyyy-MM-dd'),
          CutOffDateFrom: this.datepipe.transform(element['CutOffDateFrom'], 'yyyy-MM-dd'),
          SessionCoColgCutOffDtId: element['SessionCoColgCutOffDtId'] ? element['SessionCoColgCutOffDtId'] : 0,
        };
        addCalls.push(this.umsService.addSessionCutOff(addPayload));
      });
    });

    if (addCalls.length === 0) {
      this.spinner.hide();
      this.subButton = true;
      let data = {};
      data['message'] = 'Submitted Successfully';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        this.dialogRef2.close();
      });
      return;
    }

    forkJoin(addCalls).subscribe(
      (results: any[]) => {
        this.spinner.hide();
        results.forEach((res) => {
          if (res && res.status === false) {
            iserror = true;
            this.errMsg = res.message;
          }
        });
        if (iserror === false) {
          this.subButton = true;
          let data = {};
          data['message'] = 'Submitted Successfully';
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.dialogRef2.close();
          });
        } else {
          this.subButton = false;
          let data = {};
          data['message'] = this.errMsg;
          data['title'] = 'Alert';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.ngOnInit();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        iserror = true;
        this.errMsg = ERROR.error.message;
        this.subButton = false;
        let data = {};
        data['message'] = this.errMsg;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      }
    );
  }



  redirect(to): void {
    // this.spinner.show()
    this.router.navigate([to]);
    //this.spinner.hide();
  }


  errorcheck(i) {
    return i.controls['CutOffDate'].touched && i.controls['CutOffDate'].errors?.required
  }
  errorcheckValidator(i) {
    return i.controls['CutOffDate'].touched && i.controls['CutOffDate'].errors?.pattern
  }

  errorcheck1(i) {

    return i.controls['CutOffDateFrom'].touched && i.controls['CutOffDateFrom'].errors?.required
  }
  // errorcheckValidator1(i) {
  //   return i.controls['CutOffDateFrom'].touched && i.controls['CutOffDateFrom'].errors?.pattern
  // }

  deleteRow(index) {

    if (index !== 0) {
      this.DateArray = this.SessionCutOff.controls.DateArray.value
      this.datearr = this.DateArray[index];
      const cutoffDateFrom = new Date(this.datearr['CutOffDateFrom']);
      const currentDate = new Date(this.date);
      const CutOffDate = new Date(this.datearr['CutOffDate'])
      if (currentDate > cutoffDateFrom && currentDate < CutOffDate) {
        let data = {}
        data['message'] = 'Active Cutoff Dates Cannot Be Deleted'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
      else {
        (<FormArray>this.SessionCutOff.get("DateArray")).removeAt(index);
      }
    }
    else {
      let data = {}
      data['message'] = "First Row Can Not Be Deleted"
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    }

    // let taskListArrays = this.SessionCutOff.get('DateArray') as FormArray;
    // for (let i = index - 1; i >= 0; i--) {
    //   const currentRow = taskListArrays.controls[i];
    //   currentRow.patchValue({ "AMD": "D" });


    // }


  }



  fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        let activeFlowObject = res.projectPharam['ActiveFlow']
        let arrActiveFlow = JSON.parse(activeFlowObject);
        if(arrActiveFlow[0]['CutOffDateAllClg'] == 1){
          console.log('i have 1 value');
          this.SelectAllActive = true;
          this.GetUserWise()
          this.fetchCourse2()
        }
        else if(arrActiveFlow[0]['CutOffDateAllClg'] == 0){
          console.log('i have 0 value');
          this.SelectAllActive = false;
          this.fetchCourse2()
          //this.fetchCollege();
        }

      }
      else{
        this.spinner.hide()
      }
      // this.fetchSupExamRecord(res.projectPharam['SnNo']);
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      }
    );
  }

  fetchSupExamRecord(CoCode) {
    this.spinner.show();
    let payload = {};
    payload['EmCoCode'] = CoCode
    this.umsService.getExam(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ExamAList = res.data;
        this.filteredExamAList = this.ExamAList.slice();
      } else {
        this.ExamAList = [];
        this.filteredExamAList = this.ExamAList.slice();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filteredExamAList = this.ExamAList.slice();
      }
    );
  }

  fetchSupExamInputs() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'ACT';
    this.umsService.getCode(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ExamInputList = res.data;
        this.filteredExamInputList = this.ExamInputList.slice();
      } else {
        this.ExamAList = [];
        this.filteredExamInputList = this.ExamInputList.slice();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filteredExamInputList = this.ExamInputList.slice();
      })
  }

  toggleExamDropdown(selectedItem: any) {
    if (selectedItem === "EMFRM" || selectedItem === "ADFEE" || selectedItem === "ADM" || selectedItem === "EMFEE" || selectedItem === "MRKEN" || selectedItem === "SubSe" || selectedItem == "MRKL" || selectedItem == "IAMar") {
      this.examDropdownVisible = true;
    } else {
      this.examDropdownVisible = false;
    }
    if (selectedItem === "EMFRM" || selectedItem === "MRKEN" || selectedItem === "SubSe" || selectedItem == "MRKL" || selectedItem == "IAMar" || selectedItem == "REMFE") {

    }
    else {
      this.SessionCutOff.controls['EmId'].setValue('');
    }

  }
  getdates() {
    this.prepopulatedData(this.SessionCutOff.value)
  }

  GetUserWise(){
    this.spinner.show();
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    this.umsService.GetUserWise(payload).subscribe((res) => {
      if(res.status){
        console.log('res of user getuserwise',res.data);
        //this.collegeList = res.data;
        //this.filteredCollegeList = this.collegeList.slice();
        this.spinner.hide();
      }
      else{
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  selectAllColleges() {
    if (!this.filteredCollegeList || !Array.isArray(this.filteredCollegeList)) {
      return;
    }

    if (this.isAllCollegesSelected()) {
      // Deselect all colleges
      this.selectedColleges = [];
      this.SessionCutOff.controls['CoCgCgCode'].setValue([]); // Reset the selected values
      this.commaSeparatedColleges = '';
    } else {
      // Select all colleges (use normalized CoCgCgCode)
      this.selectedColleges = this.filteredCollegeList.map(item => item.CoCgCgCode);
      // Add all colleges and "selectAll" as the value (matches kkh behavior)
      this.SessionCutOff.controls['CoCgCgCode'].setValue([...this.selectedColleges, 'selectAll']);
      this.commaSeparatedColleges = this.selectedColleges.join(',');
    }

    this.isSelectAll = this.isAllCollegesSelected(); // Update the Select All state based on current selection
  }
 

  // Helper method to check if all colleges are selected
  isAllCollegesSelected(): boolean {
    if (!this.filteredCollegeList || !Array.isArray(this.filteredCollegeList)) {
      return false;
    }
  const currentValue = this.SessionCutOff.controls['CoCgCgCode'].value || [];
  const allCollegeCodes = this.filteredCollegeList.map(item => item.CgCode);
  return allCollegeCodes.every(code => currentValue.includes(code));
  }

  fetchCourse2() {
    this.Table = false;
    const payload = {};
    payload['CgCode'] = '';
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredCourseList = this.CourseList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
      this.filteredCourseList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  submitAll() {
    this.spinner.show()
    let payload = {}
    payload = this.SessionCutOff.value;
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        SessionID: payload['SessionID'],
        CoCgCgCode: this.commaSeparatedColleges,
        CoCgCoCode: payload['CoCgCoCode'],
        EmId: payload['EmId'],
        InCode: payload['InCode'],
        CutOffDate: payload['DateArray'][0]['CutOffDate'],
        CutOffDateFrom: payload['DateArray'][0]['CutOffDateFrom'],
        SessionCoColgCutOffDtId: payload['DateArray'][0]['SessionCoColgCutOffDtId'],
 
      },
    };
    this.httpClient.delete(this.APIService + '/students/SessionCoColgCutOff', options)
      .subscribe((s) => {
        let cc = [];
        cc.push(s);
        this.AddSessionCutOffAll();
      }, (ERROR: HttpErrorResponse) => {
        this.subButton = false
        this.spinner.hide();
      });   
  }
 
  AddSessionCutOffAll() {
    this.spinner.show();
    let payload = {}
    payload = this.SessionCutOff.value;
 
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload['DateArray'].forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            SessionID: new FormControl(payload['SessionID']),
            CoCgCgCode: new FormControl(this.commaSeparatedColleges),
            CoCgCoCode: new FormControl(payload['CoCgCoCode']),
            EmId: new FormControl(payload['EmId']),
            InCode: new FormControl(payload['InCode']),
            CutOffDate: new FormControl(this.datepipe.transform(element['CutOffDate'], 'yyyy-MM-dd')),
            CutOffDateFrom: new FormControl(this.datepipe.transform(element['CutOffDateFrom'], 'yyyy-MM-dd')),
            SessionCoColgCutOffDtId: new FormControl(element['SessionCoColgCutOffDtId'] ? element['SessionCoColgCutOffDtId'] : 0),
            UserId: new FormControl(sessionStorage.getItem('userId')),  
          })
        )
        console.log('arr1[0].value',arr1[0].value);
        this.umsService.addSessionCutOff(arr1[0].value).subscribe(res => {
          // this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
            // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
          }
          if (res.status == true) {
            iserror = false
            this.errMsg = res.message
            // this.NewCoSch();  disabled automatic course schedule api calls as discussed on 21/02/24
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
 
      });
    })
    bar.then(() => {
      if (iserror == false) {
        this.subButton = true;
        this.spinner.hide();
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef2.close()
        });
      } else {
        this.subButton = false;
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      }
    });
  }

  fetchCollegesForCourse(coCode: string, selectedCollege?: string) {
  if (!coCode) {
    this.clearColleges();
    return;
  }
  this.spinner.show();
  const payload = {
    CoCode: coCode
  };
  this.umsService.getCollegeCourse(payload).subscribe(
    (res) => {
      this.spinner.hide();
      console.log('API Response:', res);
      if (res && res.status) {
        // Normalize college code so UI + selectAll can rely on `CoCgCgCode` like kkh
        this.collegeList = (res.data || []).map(item => ({
          ...item,
          CoCgCgCode: item.CoCgCgCode || item.CgCode
        }));
        this.filteredCollegeList = this.collegeList.slice();
        // this.SessionCutOff.controls['CoCgCgCode'].setValue([]);
        // this.selectedColleges = [];
        // this.commaSeparatedColleges = '';
         if (selectedCollege) {
          this.SessionCutOff.patchValue({
            CoCgCgCode: selectedCollege
          });
        }
        
      } else {
        this.clearColleges();
      }
    },
    (error: HttpErrorResponse) => {
      this.spinner.hide();
      this.clearColleges();
    }
  );
}

onCourseSelected(event: any) {
  const selectedCourseCode = event.value;
  if (selectedCourseCode) {
    const selectedCourse = this.CourseList.find(course => course.CoCode === selectedCourseCode);
    
    if (selectedCourse) {
      this.CourseData(selectedCourse);
      this.fetchSupExamRecord(selectedCourseCode);
    } else {
      this.clearColleges();
    }
  } else {
   this.clearColleges();
  }
}
 clearColleges() {
   console.log('Clearing colleges');
   this.collegeList = [];
   this.filteredCollegeList = [];
  this.selectedColleges = [];
   this.SessionCutOff.controls['CoCgCgCode'].setValue([]);
   this.commaSeparatedColleges = '';
 }
}
